import { gql } from '@apollo/client'

import { GetSimpleProductQuery } from '../generated-types'

export type MercurySimpleProductFragment = NonNullable<
  GetSimpleProductQuery['product']
>

export const GET_SIMPLE_PRODUCT = gql`
  query GetSimpleProduct($upc: String!) {
    product(upc: $upc) {
      id
      name
      preferredName
      packagingName
      upcA
      planogramImageUrl
      marketingImageUrl
      commonName {
        id
        name
      }
      brand {
        name
      }
      manufacturer {
        name
      }
      category {
        name
      }
      packaging {
        quantity
        size
        unit
        packagingString
      }
    }
  }
`
